import { render, staticRenderFns } from "./media-add-video-list.vue?vue&type=template&id=56faefde"
import script from "./media-add-video-list.vue?vue&type=script&lang=js"
export * from "./media-add-video-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports